import { Col, DatePickerField, Flex, Row } from '@/components';
import { PS_DEFAULT_SEARCH_START_YEAR } from '@/features/public-site/utils';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { isPS } from '@/utils';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useProjectsSearchFormProviderState } from '../_common/ProjectsSearchAccordionProvider';
import { KeywordColField } from '../_common/fields/KeywordColField';
import { NestedOrganizationIdsColField } from '../_common/fields/NestedOrganizationIdsColField';
import { ProjectNumbersColField } from '../_common/fields/ProjectNumbersColField';
import { FundSheetTypeColField } from './fields/FundSheetTypeColField';

type Props = {
  resetCount: number;
  onResetPayment: () => void;
};

export const BasicSearch: FC<Props> = () => {
  const { t } = useTranslation();
  const { type } = useProjectsSearchFormProviderState();

  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectSearchFormType>();

  return (
    <Flex vertical>
      <Row gutter={16}>
        <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
          <DatePickerField
            name="fiscalYear"
            label={t('created-fiscal-year')}
            control={control}
            errors={errors}
            picker="year"
            fieldStyle={{ width: '100%' }}
            allowClear={false}
            disabledDate={
              isPS()
                ? (value) => {
                    return value.isBefore(
                      dayjs().year(PS_DEFAULT_SEARCH_START_YEAR),
                      'year',
                    );
                  }
                : undefined
            }
            disabled={type === 'group'}
          />
        </Col>
        <ProjectNumbersColField />
        <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
          {/* <SelectField
            name="sheetType"
            label={t('sheet-type')}
            hint={t('hint-search-sheet-type')}
            control={control}
            errors={errors}
            options={sheetTypeEnum.options.map((value) => ({
              value,
              label: SheetTypeLabelModifier[value],
            }))}
            shouldCoexistOnChange
            onChange={(value) => {
              if (value === 'KS') {
                setValue('fundSheetType', 'standard');
              }
              if (value === 'RS') {
                setValue('skipAdministrativeReformTeamEvaluation', 'false');
              }
              if (value !== 'RS') {
                setValue('nestedExpenditureBudgetPurposeIds', null);
                setValue('nestedPolicyIds', null);
                // amountSearchConditionsをリセット
                setValue('amountSearchConditions', [
                  {
                    amountSearchType: null,
                    amountSearchDiffAmountUnit: 'amount',
                    amountSearchDiffAmount: null,
                    amountSearchDiffOperator: null,
                    amountSearchBaseYearWithBudgetType: null,
                    amountSearchBaseYearWithBudgetTypeEnd: null,
                  },
                ]);
              }
            }}
            allowClear={false}
          /> */}
        </Col>
        <FundSheetTypeColField />
      </Row>
      <Row gutter={16}>
        <KeywordColField />
        <NestedOrganizationIdsColField />
        {/* <PaymentColField
          resetCount={resetCount}
          onResetPayment={onResetPayment}
        /> */}
      </Row>
      <Row gutter={16}>
        {/* <CategoriesColField /> */}
        {/* <ImplementationMethodsColField /> */}
        {/* <NestedPolicyIdsColField /> */}
        {/* <AccountingTypeColField />
        <AccountingTypeIdsColField /> */}
        {/* <SkipAdministrativeReformTeamEvaluationColField />
        {!isPS() && (
          <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
            <SelectField
              name="isPublished"
              label={t('publish-ability')}
              control={control}
              errors={errors}
              options={booleanStringType.options.map((value) => ({
                value,
                label: PublishedLabelModifier[value],
              }))}
            />
          </Col>
        )} */}
      </Row>
    </Flex>
  );
};
